import { InboxOutlined } from '@ant-design/icons';
import {Upload,Form,Input,message,Card,Button} from "antd"
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const { Dragger } = Upload;
const {Item}=Form


export default function RegisterPDF(props) {
  console.log(props)
  const {onCancel,propsRegister,dataUpdate}=props
  const {registerPDF}=propsRegister
  const history= useHistory();
  const [form] = Form.useForm();


    const propsDragger = {
        name: 'file',
        multiple: false,
        maxCount:1 ,
        beforeUpload: (file) => {
          const isPDF=file.type==="application/pdf" 
    
          if(!isPDF){
            message.error("El archivo no es del tipo PDF");
          }
          if(isPDF.size>16777215){
            message.error("El archivo excede los 16 MB");
          }
          return  isPDF || Upload.LIST_IGNORE
        },
        onChange(info) {
          console.log("into on change")
          console.log(info)
        },
      };


      const onFinish=()=>{
        const data=form.getFieldsValue()
        registerPDF(data)
        form.resetFields()
        onCancel()
      }

    
    useEffect(()=>{
      if(dataUpdate!=null){
        form.setFieldValue("documentApprovalName",dataUpdate)
      }
    })
    return(<>
    <Card>
        <Form
        form={form}
        onFinish={onFinish}
        >
            <Item
                name="documentApprovalName"
                label="Nombre del documento de aprobación"
                rules={[
                    {
                    required: true,
                    message: 'Ingrese el nombre del documento de permiso de funcionamiento '  
                    }
                ]}
                >
                    <Input/>
                </Item>
                
                <Item
                name="documentApprovalAttachment"
                label="Archivo para subir"
                >
                    <Dragger {...propsDragger} 
                    >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text"> 
                    Arrastre o haga click en el area para subir su documento de aprobación de funcionamiento por parte de la universidad
                    </p>
                    <p className="ant-upload-hint">
                        Solo se puede subir archivos pdf de maximo de tamaño 16 MB
                    </p>
                    </Dragger>
                </Item>
        </Form>
        <Button type="primary" onClick={() => form.submit()}>
            Finalizar
        </Button>
        <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() =>onCancel()}
          >
            Cancelar
          </Button>
    </Card>
    </>)
}